module.exports = __webpack_public_path__ + "static/media/index.c8ac1b82.less";